import { ArrowRight } from "lucide-react";
import { ZeusBolt } from "@/components/ZeusBolt";

interface EmptyStateProps {
  onSuggest: (prompt: string) => void;
}

const SUGGESTIONS = [
  {
    title: "Explain quantum computing",
    desc: "in simple terms",
    prompt: "Explain quantum computing in simple terms, as if I'm a curious 15-year-old.",
  },
  {
    title: "Write a Python script",
    desc: "for web scraping",
    prompt: "Write a Python script that scrapes the top headlines from a news website using BeautifulSoup.",
  },
  {
    title: "Help me brainstorm",
    desc: "startup ideas",
    prompt: "Help me brainstorm 5 unique startup ideas in the AI space that solve real problems.",
  },
];

export function EmptyState({ onSuggest }: EmptyStateProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 animate-fade-in">
      <div className="mb-8 flex flex-col items-center gap-4">
        <div className="relative">
          <ZeusBolt size={72} animated particles />
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-foreground mb-1">
            How can I help you today?
          </h1>
          <p className="text-sm text-muted-foreground">
            Zeus is ready to assist with anything you need.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-2xl w-full">
        {SUGGESTIONS.map((s) => (
          <button
            key={s.title}
            onClick={() => onSuggest(s.prompt)}
            className="group text-left p-4 rounded-2xl border border-border bg-card hover:bg-secondary/60 hover:border-border transition-all duration-200"
          >
            <p className="text-sm font-medium text-foreground mb-1">{s.title}</p>
            <p className="text-xs text-muted-foreground">{s.desc}</p>
            <ArrowRight className="h-3.5 w-3.5 text-muted-foreground mt-2 opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
        ))}
      </div>
    </div>
  );
}
